<template>
    <v-app>
        <NavBar v-if="!hide" />
        <SideBar v-if="!hide" />

        <v-main
            :style="{ background: $vuetify.theme.themes[theme].background }"
        >
            <router-view />
        </v-main>

        <statusSnackbar />

        <BottomNav />
    </v-app>
</template>

<script>
import SideBar from './components/SideBar/SideBar.vue';
import NavBar from './components/NavBar/NavBar.vue';
import BottomNav from './components/BottomNav/BottomNav.vue';
export default {
    name: 'App',

    components: {
        SideBar,
        NavBar,
        StatusSnackbar: () =>
            import(
                /* webpackPrefetch: true */ './components/StatusSnackbar/StatusSnackbar.vue'
            ),
        BottomNav,
    },

    data: () => ({}),
    computed: {
        theme() {
            return this.$vuetify.theme.dark ? 'dark' : 'light';
        },
        hide() {
            return this.$route.path === '/login';
        },
    },
};
</script>

<style>
.test {
    border-width: 1px !important;
    border-color: #e0e0e0 !important;
    height: 100%;
}

.v-card {
    border-radius: 10px !important;
}

.v-dialog {
    -ms-overflow-style: none !important;
    scrollbar-width: none !important;
}

.v-dialog::-webkit-scrollbar {
    display: none !important;
}

#app {
    -webkit-font-smoothing: antialiased;
}

::-webkit-scrollbar {
    width: 7px;
}

::-webkit-scrollbar-track {
    background: #ffffff;
    border-left: 0px solid #ffffff;
}

::-webkit-scrollbar-thumb {
    background: #00205a;
    border: solid 0px #e6e6e6;
    border-radius: 6px;
}

::-webkit-scrollbar-thumb:hover {
    background: rgb(0, 75, 125);
}

input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus, 
input:-webkit-autofill:active{
    -webkit-background-clip: text;
    transition: background-color 5000s ease-in-out 0s;
    box-shadow: inset 0 0 20px 20px #23232300;
}

@media (max-width: 600px) {
    body {
        overflow: hidden !important;
        max-height: 100vh !important;
        overflow-y: scroll !important;
    }
}
</style>
